export default "__VITE_ASSET__b7611fe8__"